import { WorkshopModel } from '../../features/workshop/models/workshop.model';

export enum WorkshopRegistrationRequestStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Expired = 4,
}

export class WorkshopRegistrationRequestModel {
  public id: number;
  public workshopId: number;
  public informWayId: number;
  public attendanceTypeId: number;
  public workshop: WorkshopModel;
  public registrationDateJalali: string;
  public registrationDate: any;
  public statusTitle: string;
  public status: number;
  public questions: string;

  constructor(
    id: number,
    workshopId: number,
    attendanceId: number,
    informWayId: number,
    workshop: WorkshopModel,
    registrationDateJalali: string,
    registrationDate: any,
    statusTitle: string,
    status: number,
    questions: string,
  ) {
    this.id = id;
    this.workshop = workshop;
    this.registrationDateJalali = registrationDateJalali;
    this.registrationDate = registrationDate;
    this.statusTitle = statusTitle;
    this.status = status;
    this.questions = questions;
  }
}
